/**
 * <pre>
 * Overlay config.
 *
 * Summary of responsibilities:
 *
 *  - defines any commonly used config values specific to Overlays.
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Overlay
 * @namespace
 *
 * @type {Object}
 */
const Config = {

	// The key to use when creating the root store using combineReducers.
	stateKey: 'overlay',

	// Initial position mode.
	positionMode:'xPositionScreen',

	// Initial top offset.
	top:0
};

export default Config;
